import { ArrowUpRight } from "lucide-react";
import { Button } from "components/ui/button";
import PageMeta from "../components/PageMeta";
import { ContactCTA, RequestButton } from "../components/SiteShell";
import { contact } from "../content";
import ServiceCharter from "../components/ServiceCharter";
export default function About() {
  return (
    <>
      <PageMeta
        title="Our approach | Owners First"
        description="A manager who knows your building and listens to its people. Learn about our hands-on approach and customer service charter."
      />
      <section className="site-wrap site-page-intro">
        <h1>
          Less corporate.
          <br />
          <span>More connected.</span>
        </h1>
        <div>
          <p>
            We’re here to make owners corporation management feel more personal.
            More involved. And a whole lot clearer.
          </p>
          <RequestButton />
        </div>
      </section>
      <div className="site-wrap site-wide-image site-about-image">
        <img
          src="/images/about-courtyard.jpg"
          alt="Two people walking and talking in a landscaped brick apartment courtyard"
          fetchpriority="high"
          width="1792"
          height="1024"
        />
      </div>
      <section className="site-wrap site-section site-about-story">
        <h2>
          Our name is
          <br />
          our commitment.
        </h2>
        <div>
          <p>
            At Owners First, we look after buildings by paying attention to the
            people who use them. That means listening carefully, communicating
            openly and getting to know your property in person.
          </p>
          <p>
            We don’t believe effective management happens entirely behind a
            desk. Regular visits and everyday conversations help us understand
            what your community needs.
          </p>
          <p>
            Our customer service charter puts those expectations into words, so
            you know what to expect from us.
          </p>
        </div>
      </section>
      <ServiceCharter />
      <section className="site-wrap site-personal-contact">
        <h2>
          A real conversation.
          <br />A good place to start.
        </h2>
        <Button variant="outline" size="lg" asChild>
          <a href={`mailto:${contact.email}`}>
            Say hello
            <ArrowUpRight data-icon="inline-end" />
          </a>
        </Button>
      </section>
      <ContactCTA />
    </>
  );
}
